import { Header } from '@hwm/ui-lib';
import { makeStyles, Theme } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles((theme: Theme) => ({
  label: {
    height: 40,
    minHeight: 40,
    margin: theme.spacing(0, 0, 1),
  },
  wrappedLabel: {
    [theme.breakpoints.down('xs')]: {
      height: 76,
      minHeight: 76,
      alignItems: 'flex-start',
      flexDirection: 'column',
      maxWidth: '100%',
    },
  },
  buttonsWrapper: {
    height: 32,
    '& button': {
      height: 32,
    },

    [theme.breakpoints.down('xs')]: {
      justifyContent: 'space-between',
      '& button': {
        height: 28,
        marginLeft: 0,
        marginRight: theme.spacing(1),
      },
    },
  },
}));

interface CustomHeaderProps {
  title: string;
  /**
   * each one to contain `dataTestId` name of a button (preferably `<name>-header-buttons-<btn_name>-button`)
   * @example
   * [
   *  <Button dataTestId="test-header-buttons-example-button">Example</Button>
   *  <Button dataTestId="test-header-buttons-another-button">Another</Button>
   * ]
   */
  buttons?: JSX.Element[];
  wrapButtons?: boolean;
  hideDivider?: boolean;
  /**
   * `dataTestId` - name of a header (preferably `<name>-header`)
   * @example
   * ```tsx
   * <CustomHeader {...props} dataTestId="test-header" />
   */
  dataTestId?: string;
}

export const CustomHeader: React.FC<CustomHeaderProps> = ({
  title,
  buttons,
  wrapButtons = false,
  hideDivider = false,
  dataTestId,
}) => {
  const classes = useStyles();

  return (
    <Header
      title={title}
      buttons={
        buttons ? (
          <>
            {buttons.map((btn, i) => (
              <React.Fragment key={i}>{btn}</React.Fragment>
            ))}
          </>
        ) : null
      }
      labelContainerClasses={`${classes.label} ${wrapButtons ? classes.wrappedLabel : ''}`}
      buttonsContainerClasses={`${classes.buttonsWrapper}`}
      truncateTitle
      showDivider={!hideDivider}
      dataTestId={dataTestId}
    />
  );
};
